import { render, staticRenderFns } from "./SliderHandlerV2.vue?vue&type=template&id=38a68483&scoped=true&"
import script from "./SliderHandlerV2.vue?vue&type=script&lang=js&"
export * from "./SliderHandlerV2.vue?vue&type=script&lang=js&"
import style0 from "./SliderHandlerV2.vue?vue&type=style&index=0&id=38a68483&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a68483",
  null
  
)

export default component.exports